// CB1000GT Store: delivery estimate UI (snippets/cb-delivery-estimate.liquid).
// Pure logic lives in cb-delivery-logic.js (window.CBDelivery); this module only touches the DOM.
//
// Test mode (NOT on the live theme, only when Shopify.theme.role !== 'main', e.g. ?preview_theme_id=…):
//   ?cbtest=A|B|C              force the stock state on any product
//   &cbnow=2026-10-02T15:59:00%2B02:00   pretend it is this moment (ISO with offset)
//   &cbbf30=<product-handle>   show the BF30 card using another (published) product
import { CartAddEvent } from '@theme/events';

const POSTNL = {
  Austria: '3-4', Belgium: '1-2', Bulgaria: '4-6', Croatia: '5-8', Cyprus: '4-6', Czechia: '3-6', Denmark: '2-3',
  Estonia: '4-6', Finland: '3-6', France: '2-4', Germany: '2-3', Greece: '3-6', Hungary: '3-6', Ireland: '2-4',
  Italy: '3-5', Latvia: '3-6', Lithuania: '4-6', Luxembourg: '1-2', Malta: '3-6', Netherlands: '1', Poland: '3-4',
  Portugal: '3-5', Romania: '3-6', Slovakia: '3-6', Slovenia: '2-4', Spain: '3-5', Sweden: '3-5',
};

const params = new URLSearchParams(location.search);
const testMode = Boolean(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');
const routes = typeof Theme !== 'undefined' ? Theme.routes : {};
const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

function now() {
  const forced = testMode && params.get('cbnow');
  const d = forced ? new Date(forced) : new Date();
  return isNaN(d.getTime()) ? new Date() : d;
}

function readData() {
  if (testMode && params.get('cbtest')) return { forced: params.get('cbtest').toUpperCase(), variants: {} };
  const el = document.getElementById('cbship-data');
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    console.error('[cb-delivery] bad data', e);
    return null;
  }
}

function place(wrap) {
  const anchor = [...document.querySelectorAll('.product-form-buttons')].find((a) => !a.closest('sticky-add-to-cart'));
  if (anchor && anchor.parentNode) return anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
  const rec = document.querySelector('[id*="product_recommendations"]');
  if (rec && rec.parentNode) rec.parentNode.insertBefore(wrap, rec);
}

function init() {
  const L = window.CBDelivery;
  const wrap = document.getElementById('cbship-wrap');
  if (!wrap || !L) return;
  place(wrap);
  wrap.style.display = '';

  const sel = document.getElementById('cbship-country');
  const out = document.getElementById('cbship-out');
  const stockEl = document.getElementById('cbship-stock');
  const data = readData();
  let variantId = data && !data.forced ? String(params.get('variant') || data.current) : null;

  function currentState() {
    if (!data) return null;
    if (data.forced) return ['A', 'B', 'C'].includes(data.forced) ? data.forced : 'C';
    return L.pickState(data.variants[variantId], now());
  }

  function render() {
    const state = currentState();
    const info = state ? L.dispatchInfo(state, now()) : null;

    if (state && stockEl) {
      let html;
      if (state === 'A') {
        html = info.today
          ? '<strong>In stock</strong> — order before 16:00 and it ships <strong>today</strong>.'
          : `<strong>In stock</strong> — ships on <strong>${L.formatDate(info.dispatch)}</strong>.` +
            '<small>We ship Tuesday to Saturday: orders placed before 16:00 (CET) ship the same day.</small>';
      } else if (state === 'B') {
        html =
          `<strong>Available from our supplier</strong> — ships on <strong>${L.formatDate(info.dispatch)}</strong>.` +
          '<small>Orders placed before 16:00 (CET), Monday to Friday, arrive from our supplier and ship the next day.</small>';
      } else {
        html = "<strong>On request</strong> — we'll email you the expected delivery time.";
      }
      stockEl.innerHTML = `<span class="cbship__dot cbship__dot--${state.toLowerCase()}"></span><span>${html}</span>`;
      stockEl.hidden = false;
    }

    const country = sel && sel.value;
    const transit = POSTNL[country];
    if (!out) return;
    if (!transit) {
      out.hidden = true;
      out.innerHTML = '';
      return;
    }
    out.hidden = false;
    if (info) {
      const range = L.deliveryRange(transit, info.workdays);
      out.innerHTML =
        `Estimated delivery to <strong>${country}</strong>: approx. <span class="cbship__days">${range} working days</span>` +
        ' (dispatch + PostNL transit).';
    } else {
      const unit = transit === '1' ? 'working day' : 'working days';
      out.innerHTML =
        state === 'C'
          ? `PostNL transit to <strong>${country}</strong>: approx. <span class="cbship__days">${transit} ${unit}</span> after dispatch.`
          : // Not a Hoco product: exactly the original wording.
            `Estimated delivery to <strong>${country}</strong>: approx. <span class="cbship__days">${transit} ${unit}</span> with PostNL.`;
    }
  }

  if (sel) sel.addEventListener('change', render);
  // Horizon fires `variant:update` with the new variant in detail.resource.
  document.addEventListener('variant:update', (event) => {
    const id = event.detail && event.detail.resource && event.detail.resource.id;
    if (id) {
      variantId = String(id);
      render();
    }
  });
  document.addEventListener('change', (event) => {
    const t = event.target;
    if (t instanceof HTMLInputElement && t.name === 'id' && t.value) {
      variantId = String(t.value);
      render();
    }
  });
  render();
  initBf30();
}

// --- "Required: GIVI BF30 flange" card on tank bags -------------------------------------------------

function money(cents) {
  const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  // Match the store's price style ("€133,33", no space after the symbol).
  return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: cur }).format(cents / 100).replace(/\s/g, '');
}

async function fetchCart() {
  const url = `${routes.cart_url || '/cart'}.js`;
  return fetch(url, { headers: { Accept: 'application/json' } }).then((r) => r.json());
}

async function initBf30() {
  let box = document.getElementById('cbship-bf30');
  let handle = box && box.dataset.handle;
  if (testMode && params.get('cbbf30')) {
    handle = params.get('cbbf30');
    if (!box) {
      box = document.createElement('div');
      box.className = 'cbship__bf30';
      box.id = 'cbship-bf30';
      box.hidden = true;
      document.getElementById('cbship-wrap').prepend(box);
    }
  }
  if (!box || !handle) return;

  try {
    const res = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
    if (!res.ok) return; // not published (yet): no card, the description link remains
    const p = await res.json();
    const v = p.variants.find((x) => x.available) || p.variants[0];
    if (!v) return;
    const cart = await fetchCart();
    const inCart = (cart.items || []).some((i) => i.variant_id === v.id);
    const img = p.featured_image ? `<img src="${p.featured_image}&width=120" alt="" loading="lazy">` : '';
    box.innerHTML =
      img +
      `<div class="cbship__bf30-txt"><strong>Required: <a href="${p.url}">GIVI BF30 Tanklock flange</a></strong>` +
      `<span>Fits this tank bag to the CB1000GT fuel cap · ${money(v.price)}</span></div>` +
      (inCart
        ? '<span class="cbship__bf30-ok">✓ In your cart</span>'
        : `<button type="button" class="cbship__bf30-btn" data-variant="${v.id}">Add to cart</button>`);
    box.hidden = false;

    const btn = box.querySelector('.cbship__bf30-btn');
    if (btn) btn.addEventListener('click', () => addBf30(btn, v.id));
  } catch (e) {
    console.error('[cb-delivery] bf30', e);
  }
}

async function addBf30(btn, variantId) {
  btn.disabled = true;
  try {
    const res = await fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    });
    if (!res.ok) throw new Error(`cart/add ${res.status}`);
    const cart = await fetchCart();
    document.dispatchEvent(
      new CartAddEvent(cart, 'cb-delivery-bf30', { source: 'cb-delivery-bf30', itemCount: cart.item_count, variantId: String(variantId) })
    );
    btn.outerHTML = '<span class="cbship__bf30-ok">✓ Added to your cart</span>';
  } catch (e) {
    console.error('[cb-delivery] add bf30', e);
    btn.disabled = false;
  }
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
